// Module Vuex pour la gestion du routeur
// Traduit depuis apps/pwa/src/Reducer/Router.js

const state = {
  currentRoute: null,
  queries: {},
  params: {},
  history: []
}

const mutations = {
  SET_CURRENT_ROUTE(state, route) {
    state.currentRoute = route
    state.queries = route.query || {}
    state.params = route.params || {}
  },
  
  ADD_TO_HISTORY(state, route) {
    state.history.push(route)
  },
  
  CLEAR_HISTORY(state) {
    state.history = []
  }
}

const actions = {
  setCurrentRoute({ commit }, route) {
    commit('SET_CURRENT_ROUTE', route)
    commit('ADD_TO_HISTORY', route)
  },
  
  clearHistory({ commit }) {
    commit('CLEAR_HISTORY')
  }
}

const getters = {
  currentRoute: state => state.currentRoute,
  queries: state => state.queries,
  params: state => state.params,
  history: state => state.history
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
